import { render, staticRenderFns } from "./SpecificCreditRuleBuilder.vue?vue&type=template&id=ec70d894&scoped=true"
import script from "./SpecificCreditRuleBuilder.vue?vue&type=script&lang=ts"
export * from "./SpecificCreditRuleBuilder.vue?vue&type=script&lang=ts"
import style0 from "./SpecificCreditRuleBuilder.vue?vue&type=style&index=0&id=ec70d894&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70d894",
  null
  
)

export default component.exports